import type { Uuid } from "@/domains/global/identifiers";
import type { IAudioTransformingStore } from "@/store/audio/transforming/audio-transforming.types";

import { TerminalOutcome } from "./audio-pipeline.types";
import { failResult, okResult, type StageResult } from "./stage-result";

/**
 * Transform-stage adapter. Enqueues the transformer and waits for it to
 * reach a terminal state. The transformer is now a pure worker — it expects
 * a Ready transcript and produces a suggestion.
 */
export async function runTransformStage({
  audioRecordingId,
  transformingStore,
}: {
  audioRecordingId: Uuid;
  transformingStore: IAudioTransformingStore;
}): Promise<StageResult> {
  await transformingStore.enqueue({ audioRecordingId });

  const result = await transformingStore.waitForTransformComplete({ audioRecordingId });
  if (result.success) {
    return okResult();
  }

  return failResult(TerminalOutcome.TransformFailed, {
    kind: "transform-failed",
    message: result.error || "Processing failed",
  });
}
